import { createClient } from '@supabase/supabase-js'

const URL = 'https://nfmgrlybgijzwobpzkad.supabase.co'
const KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5mbWdybHliZ2lqendvYnB6a2FkIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzU4MTA4NjIsImV4cCI6MTk5MTM4Njg2Mn0.j-Weg02DEEn-s02ddJ2qA4uoxWEkvh3UgmPRGzhRRZ4'

export var supabase = createClient(URL, KEY)
